module.exports = __webpack_public_path__ + "img/CharacterSheetPage3.4e0a049a.png";